import OrchestratorAPI from './common';

import {
  CreateValues,
  EhrInstance,
  EhrInstanceWithPracticeIds,
  FindAllOptions,
  Kind as Ehr,
  UpdateValues as EhrInstanceUpdateValues,
} from '../models/orchestrator/ehrInstance';
import {
  DowntimeCreateValues,
  EhrInstanceDowntime,
  EhrInstanceIsDowntime,
  UpdateValues as EhrInstanceDowntimeUpdateValues,
} from '../models/orchestrator/ehrInstanceDowntime';

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/ehr-instances';

  async findAll(
    options: FindAllOptions & { includePracticeIds?: boolean } = {},
  ): Promise<EhrInstanceWithPracticeIds[]> {
    const url = this.constructPath('/', options);
    const { ehrInstances } = await this.common.getJSON(url);
    return ehrInstances.map(this.deserialize);
  }

  async findAllKinds(): Promise<Ehr[]> {
    const url = this.constructPath('/kinds');
    return this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<EhrInstance> {
    const url = this.constructPath(`/${id}`);
    const { ehrInstance } = await this.common.getJSON(url);
    return this.deserialize(ehrInstance);
  }

  async create(values: CreateValues): Promise<EhrInstance> {
    const url = this.constructPath('/');
    const { ehrInstance } = await this.common.postJSON(url, values);
    return this.deserialize(ehrInstance);
  }

  async update(
    id: string,
    values: EhrInstanceUpdateValues,
  ): Promise<EhrInstance> {
    const url = this.constructPath(`/${id}`);
    const { ehrInstance } = await this.common.patchJSON(url, values);
    return this.deserialize(ehrInstance);
  }

  async remove(id: string): Promise<void> {
    const url = this.constructPath(`/${id}`);
    return this.common.deleteJSON(url);
  }

  async getDowntime(id: string): Promise<EhrInstanceIsDowntime> {
    const url = this.constructPath(`/${id}/downtime`);
    return this.common.getJSON(url);
  }

  async findAllDowntimes(id: string): Promise<EhrInstanceDowntime[]> {
    const url = this.constructPath(`${id}/downtimes`);
    const { downtimes } = await this.common.getJSON(url);
    return downtimes;
  }

  async createDowntime(
    id: string,
    values: DowntimeCreateValues,
  ): Promise<EhrInstanceDowntime> {
    const url = this.constructPath(`/${id}/downtime`);
    const ehrInstanceDowntime = await this.common.postJSON(url, values);
    return this.deserialize(ehrInstanceDowntime);
  }

  async updateDowntime(
    ehrInstanceId: string,
    downtimeId: string,
    values: EhrInstanceDowntimeUpdateValues,
  ): Promise<EhrInstanceDowntime> {
    const url = this.constructPath(`/${ehrInstanceId}/downtime/${downtimeId}`);
    const { ehrInstanceDowntime } = await this.common.patchJSON(url, values);
    return this.deserialize(ehrInstanceDowntime);
  }

  async removeDowntime(
    ehrInstanceId: string,
    downtimeId: string,
  ): Promise<void> {
    const url = this.constructPath(`/${ehrInstanceId}/downtime/${downtimeId}`);
    return this.common.deleteJSON(url);
  }
}
